import React, { useState, useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import {
  EuiTitle,
  EuiSpacer,
  EuiFlexGroup,
  EuiFlexItem,
  EuiIcon,
  EuiText,
  EuiPanel,
} from "@elastic/eui";

const Home: React.FC = () => {
  const { user } = useAuth();
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const getGreeting = () => {
    const hour = currentTime.getHours();
    if (hour < 12) return "Chào buổi sáng";
    if (hour < 18) return "Chào buổi chiều";
    return "Chào buổi tối";
  };

  const formatDateTime = (date: Date) => {
    return {
      time: date.toLocaleTimeString("vi-VN", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }),
      date: date.toLocaleDateString("vi-VN", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      }),
    };
  };

  // Prioritize full name from tblDmEmployee, then fullName, then userName
  const displayName =
    user?.tblDmEmployee?.fullname ||
    user?.fullName ||
    user?.userName ||
    "Người dùng";
  const { time, date } = formatDateTime(currentTime);

  return (
    <div style={{ padding: "24px" }}>
      {/* Header Section */}
      <EuiPanel
        paddingSize="l"
        style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "white",
          marginBottom: "24px",
        }}
      >
        <EuiFlexGroup alignItems="center" justifyContent="spaceBetween">
          <EuiFlexItem grow={false}>
            <div>
              <EuiTitle size="l">
                <h1 style={{ color: "white", margin: 0 }}>
                  {getGreeting()}, {displayName}! 👋
                </h1>
              </EuiTitle>
              <EuiSpacer size="s" />
              <EuiText style={{ color: "rgba(255,255,255,0.9)" }}>
                <p>Chào mừng bạn đến với hệ thống quản lý Hacom.vn</p>
              </EuiText>
            </div>
          </EuiFlexItem>
          <EuiFlexItem grow={false}>
            <div style={{ textAlign: "right" }}>
              <div
                style={{
                  fontSize: "32px",
                  fontWeight: "bold",
                  color: "white",
                  fontFamily: "monospace",
                }}
              >
                {time}
              </div>
              <div
                style={{
                  fontSize: "14px",
                  color: "rgba(255,255,255,0.8)",
                  marginTop: "4px",
                }}
              >
                {date}
              </div>
            </div>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiPanel>

      {/* Stats Section */}
      <EuiFlexGroup gutterSize="l">
        <EuiFlexItem>
          <EuiPanel paddingSize="l" style={{ textAlign: "center" }}>
            <EuiIcon type="globe" size="xl" color="primary" />
            <EuiSpacer size="m" />
            <EuiTitle size="s">
              <h3>Website Hacom.vn</h3>
            </EuiTitle>
            <EuiText color="subdued">
              <p>Hệ thống quản lý website thương mại điện tử</p>
            </EuiText>
          </EuiPanel>
        </EuiFlexItem>

        <EuiFlexItem>
          <EuiPanel paddingSize="l" style={{ textAlign: "center" }}>
            <EuiIcon type="managementApp" size="xl" color="success" />
            <EuiSpacer size="m" />
            <EuiTitle size="s">
              <h3>Quản lý sản phẩm</h3>
            </EuiTitle>
            <EuiText color="subdued">
              <p>Quản lý danh mục, sản phẩm và thông tin kỹ thuật</p>
            </EuiText>
          </EuiPanel>
        </EuiFlexItem>

        <EuiFlexItem>
          <EuiPanel paddingSize="l" style={{ textAlign: "center" }}>
            <EuiIcon type="users" size="xl" color="warning" />
            <EuiSpacer size="m" />
            <EuiTitle size="s">
              <h3>Quản lý khách hàng</h3>
            </EuiTitle>
            <EuiText color="subdued">
              <p>Quản lý thông tin khách hàng và đơn hàng</p>
            </EuiText>
          </EuiPanel>
        </EuiFlexItem>

        <EuiFlexItem>
          <EuiPanel paddingSize="l" style={{ textAlign: "center" }}>
            <EuiIcon type="stats" size="xl" color="danger" />
            <EuiSpacer size="m" />
            <EuiTitle size="s">
              <h3>Báo cáo thống kê</h3>
            </EuiTitle>
            <EuiText color="subdued">
              <p>Thống kê doanh số và phân tích dữ liệu</p>
            </EuiText>
          </EuiPanel>
        </EuiFlexItem>
      </EuiFlexGroup>

      <EuiSpacer size="l" />

      {/* User Info Section */}
      <EuiFlexGroup gutterSize="l">
        <EuiFlexItem grow={2}>
          <EuiPanel paddingSize="l">
            <EuiTitle size="s">
              <h3>Thông tin người dùng</h3>
            </EuiTitle>
            <EuiSpacer size="m" />

            <EuiFlexGroup alignItems="center" gutterSize="m">
              <EuiFlexItem grow={false}>
                <div
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontSize: "24px",
                    fontWeight: "bold",
                  }}
                >
                  {displayName.charAt(0).toUpperCase()}
                </div>
              </EuiFlexItem>
              <EuiFlexItem>
                <div>
                  <strong>
                    {user?.tblDmEmployee?.fullname || displayName}
                  </strong>
                  <br />
                  <EuiText size="s" color="subdued">
                    ID: {user?.empId || "N/A"} |{" "}
                    {user?.tblDmEmployee?.code || "N/A"}
                  </EuiText>
                  <br />
                  <EuiText size="s" color="subdued">
                    📧{" "}
                    {user?.email ||
                      user?.tblDmEmployee?.email ||
                      "Không có email"}
                  </EuiText>
                  <br />
                  <EuiText size="s" color="subdued">
                    🏢{" "}
                    {user?.departmentName ||
                      user?.tblDmEmployee?.departmentName ||
                      "Không xác định"}
                  </EuiText>
                  <br />
                  <EuiText size="s" color="subdued">
                    🏪{" "}
                    {user?.tblDmEmployee?.brachName ||
                      "Không có thông tin chi nhánh"}
                  </EuiText>
                  <br />
                  <EuiText size="s" color="subdued">
                    📍 {user?.tblDmEmployee?.workAddress || "Không có địa chỉ"}
                  </EuiText>
                </div>
              </EuiFlexItem>
            </EuiFlexGroup>
          </EuiPanel>
        </EuiFlexItem>

        <EuiFlexItem>
          <EuiPanel paddingSize="l">
            <EuiTitle size="s">
              <h3>Truy cập nhanh</h3>
            </EuiTitle>
            <EuiSpacer size="m" />

            <div
              style={{ display: "flex", flexDirection: "column", gap: "12px" }}
            >
              <a
                href="/product-manager/product-list"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "8px",
                  borderRadius: "6px",
                  textDecoration: "none",
                  color: "#0077cc",
                }}
              >
                <EuiIcon type="package" />
                Quản lý sản phẩm
              </a>
              <a
                href="/sales-manager/order-list"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "8px",
                  borderRadius: "6px",
                  textDecoration: "none",
                  color: "#0077cc",
                }}
              >
                <EuiIcon type="document" />
                Danh sách đơn hàng
              </a>
              <a
                href="/customer/user-comment"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "8px",
                  borderRadius: "6px",
                  textDecoration: "none",
                  color: "#0077cc",
                }}
              >
                <EuiIcon type="user" />
                Quản lý khách hàng
              </a>
            </div>
          </EuiPanel>
        </EuiFlexItem>
      </EuiFlexGroup>

      <EuiSpacer size="l" />

      {/* Footer */}
      <EuiPanel
        paddingSize="m"
        style={{ textAlign: "center", background: "#f7f9fc" }}
      >
        <EuiText size="s" color="subdued">
          <p>
            © {new Date().getFullYear()} Hacom.vn - Hệ thống quản lý nội dung
            website
            <br />
            Phiên bản 1.0.0 | Môi trường: {user?.env || "Production"}
          </p>
        </EuiText>
      </EuiPanel>
    </div>
  );
};

export default Home;
